module.exports = __webpack_public_path__ + "static/media/sk.json.be67debb.orig";


//////////////////
// WEBPACK FOOTER
// ./src/assets/i18n/sk.json.orig
// module id = 607
// module chunks = 0